import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { API } from "./util";

export const Ctx = createContext(null);

export function DataProvider({ children }) {
  const [data, setData] = useState(null);
  const reload = useCallback(() => Promise.all(["recipes", "guides", "categories", "ingredients"].map(p => fetch(`${API}/${p}`).then(r => r.json())))
    .then(([recipes, guides, categories, ingredients]) => {
      const BY = Object.fromEntries(recipes.map(r => [r.slug, r]));
      const GBY = Object.fromEntries(guides.map(g => [g.slug, g]));
      const CBY = Object.fromEntries(categories.map(c => [c.key, c]));
      const IBY = Object.fromEntries(ingredients.map(p => [p.slug, p]));
      setData({ recipes, guides, categories, ingredients, BY, GBY, CBY, IBY, reload });
    }), []);
  useEffect(() => { reload(); }, [reload]);
  return <Ctx.Provider value={data}>{children}</Ctx.Provider>;
}

export const useData = () => useContext(Ctx);
export const tagged = (recipes, tag) => recipes.filter(r => r.tags.includes(tag));
